var map = {
	"./features/admin/partials/admin_home.html": "1duI",
	"./features/admin/partials/edit_org.html": "1yDb",
	"./features/admin/partials/stats.html": "iSop",
	"./features/admin/partials/styleguide.html": "6rcN",
	"./features/alerting/partials/alert_howto.html": "wvI5",
	"./features/alerting/partials/alert_tab.html": "0LRa",
	"./features/annotations/partials/editor.html": "RyIb",
	"./features/annotations/partials/event_editor.html": "vk65",
	"./features/dashboard/components/VersionHistory/template.html": "wxmp",
	"./features/datasources/partials/http_settings.html": "11hs",
	"./features/datasources/partials/http_settings_next.html": "WtGe",
	"./features/datasources/partials/tls_auth_settings.html": "/2Ru",
	"./features/panel/panellinks/module.html": "bDa/",
	"./features/panel/partials/query_editor_row.html": "oEL2",
	"./features/playlist/partials/playlist.html": "krwA",
	"./features/playlist/partials/playlist_search.html": "4x4p",
	"./features/playlist/partials/playlists.html": "M76c",
	"./features/plugins/partials/plugin_page.html": "0+gp",
	"./features/plugins/partials/update_instructions.html": "X4jf",
	"./partials/confirm_modal.html": "iKVC",
	"./partials/edit_json.html": "Ukuu",
	"./partials/modal.html": "/YHu",
	"./partials/reset_password.html": "YRnh",
	"./partials/signup_invited.html": "7teh",
	"./plugins/datasource/cloud-monitoring/partials/annotations.editor.html": "A8yJ",
	"./plugins/datasource/cloud-monitoring/partials/config.html": "UX4z",
	"./plugins/datasource/cloudwatch/partials/annotations.editor.html": "E1lu",
	"./plugins/datasource/cloudwatch/partials/query.parameter.html": "hSYD",
	"./plugins/datasource/elasticsearch/partials/annotations.editor.html": "LzuI",
	"./plugins/datasource/grafana-azure-monitor-datasource/partials/annotations.editor.html": "Qinm",
	"./plugins/datasource/grafana-azure-monitor-datasource/partials/query.editor.html": "ADUO",
	"./plugins/datasource/grafana/partials/annotations.editor.html": "/8l8",
	"./plugins/datasource/graphite/partials/annotations.editor.html": "2rVl",
	"./plugins/datasource/graphite/partials/query.editor.html": "ePCq",
	"./plugins/datasource/influxdb/partials/annotations.editor.html": "Szrz",
	"./plugins/datasource/influxdb/partials/query.editor.html": "/HFP",
	"./plugins/datasource/loki/partials/annotations.editor.html": "3CYn",
	"./plugins/datasource/mssql/partials/annotations.editor.html": "PQb9",
	"./plugins/datasource/mssql/partials/config.html": "1kYe",
	"./plugins/datasource/mssql/partials/query.editor.html": "U1ax",
	"./plugins/datasource/mysql/partials/annotations.editor.html": "9RCP",
	"./plugins/datasource/mysql/partials/config.html": "7ym3",
	"./plugins/datasource/mysql/partials/query.editor.html": "gw38",
	"./plugins/datasource/opentsdb/partials/annotations.editor.html": "s+LN",
	"./plugins/datasource/opentsdb/partials/query.editor.html": "vhkK",
	"./plugins/datasource/postgres/partials/annotations.editor.html": "I+An",
	"./plugins/datasource/postgres/partials/config.html": "diqK",
	"./plugins/datasource/postgres/partials/query.editor.html": "HmKx",
	"./plugins/datasource/prometheus/partials/annotations.editor.html": "jaLZ",
	"./plugins/panel/alertlist/editor.html": "phJb",
	"./plugins/panel/alertlist/module.html": "0ZQg",
	"./plugins/panel/graph/axes_editor.html": "ZG7E",
	"./plugins/panel/graph/tab_display.html": "Lmi3",
	"./plugins/panel/graph/tab_legend.html": "/XDc",
	"./plugins/panel/graph/tab_series_overrides.html": "8Hts",
	"./plugins/panel/graph/tab_thresholds.html": "HCwt",
	"./plugins/panel/graph/tab_time_regions.html": "TcCK",
	"./plugins/panel/graph/thresholds_form.html": "zJCM",
	"./plugins/panel/graph/time_regions_form.html": "pDgv",
	"./plugins/panel/heatmap/module.html": "NoBN",
	"./plugins/panel/heatmap/partials/axes_editor.html": "vInx",
	"./plugins/panel/heatmap/partials/display_editor.html": "mCU5",
	"./plugins/panel/pluginlist/module.html": "UJAu",
	"./plugins/panel/singlestat/editor.html": "hE9y",
	"./plugins/panel/singlestat/mappings.html": "2euF",
	"./plugins/panel/singlestat/module.html": "8iRp",
	"./plugins/panel/table-old/column_options.html": "cu9u",
	"./plugins/panel/table-old/editor.html": "KVWU",
	"./plugins/panel/table-old/module.html": "lEy4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vFKA";